<template>
  <div id="task">
    <comheader></comheader>
    <div class="rf ks_right" id="rmodel">
      <comtop></comtop>
      <el-main>
        <div class="com_topaside">
          <span>培训<b>></b></span>
          <span>考试管理<b>></b></span>
          <span>考试任务<b></b></span>
        </div>
        <div class="com_typography">
          <el-input
            placeholder="请输入内容"
            @blur="levelText"
            v-model="input"
            class="com_search lf"
            @change="searchtxt"
            ><i slot="prefix" class="el-input__icon el-icon-search"></i
          ></el-input>
          <el-button
            type="primary"
            class="add_exam"
            icon="el-icon-plus"
            @click="hrefto"
            >新建考试</el-button
          >
          <el-checkbox
            v-model="checked"
            class="rf com_checked"
            @change="chageMe"
            >只看我创建的</el-checkbox
          >
          <div class="com_task rf">
            <el-radio-group
              v-model="isCollapse"
              style="margin-bottom: 20px"
              @change="radiocount"
            >
              <el-radio-button
                :label="ix"
                v-for="(item, ix) in inGlist"
                :key="ix"
                >{{
                  ix == "0"
                    ? "全部(" + item + ")"
                    : ix == "1"
                    ? "未开始(" + item + ")"
                    : ix == "2"
                    ? "进行中(" + item + ")"
                    : "已结束(" + item + ")"
                }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </div>
      </el-main>
      <el-main class="exam_wrap">
        <el-table
          :data="taskList"
          border
          style="width: 100%"
          class="exam_table exam_task"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column
            v-for="info in tHeadr"
            :key="info.key"
            :property="info.key"
            :label="info.label"
            :width="info.width"
          >
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] }}
              <!-- 渲染对应表格里面的内容 -->
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" class="exam_btn">
              <el-button @click="handleClick(scope)" type="text" size="large"
                >监控数据</el-button
              >
              <el-button
                type="text"
                size="large"
                @click="delexam(scope.$index, scope.row.t_id)"
                class="exam_delbtn"
                >删除</el-button
              >
              <el-dropdown @command="handleCommand">
                <el-button class="el-dropdown-link" type="text">
                  更多<i
                    class="el-icon-arrow-down el-icon--right more-right"
                  ></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="delay(scope)"
                    >延期</el-dropdown-item
                  >
                  <!-- <el-dropdown-item @click.native="editPeo">变更</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="" style="margin-top: 20px" @click="deltakeall()"
          >删除选中文件</el-button
        >
        <commonPage
          :count="count"
          :Page.sync="page"
          @pagenation="pagetion"
        ></commonPage>
      </el-main>
    </div>
    <el-dialog
      title="延期时间"
      :visible.sync="delayTime"
      custom-class="dialogAddtime"
    >
      <div class="diaowraptime">
        <div class="dialogtime">
          <span>开始时间：</span>
          <el-date-picker v-model="s_time" type="datetime" disabled>
          </el-date-picker>
        </div>
        <div class="dialogtime">
          <span>结束时间：</span>
          <el-date-picker
            v-model="e_time"
            type="datetime"
            @focus="endtime"
            :picker-options="pickerOptionsEnd"
            @change="logTimeChange"
            value-format="yyyy-MM-dd"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </div>
      </div>
      <div slot="footer" class="dialogtimefoot">
        <el-button type="primary" @click="delayTimeUp">保存</el-button>
        <el-button @click="delayTime = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="变更"
      :visible.sync="changeArr"
      custom-class="dialogAddtime"
    >
      <div class="diaowrapArr">
        可见范围：<el-radio v-model="radio" label="1">全部</el-radio
        ><el-radio v-model="radio" label="2">部门/人员</el-radio>
        <el-button type="primary" v-show="radio == 2" @click="bmview"
          ><i class="el-icon-plus"></i>添加</el-button
        >
      </div>
      <!-- <div class="diaowrapArr">
                已选学员：<el-tag
                            type="info"
                            effect="plain">
                            许凤英
                        </el-tag>
            </div> -->
      <div class="diaowrapArr">
        <p>
          提示：新增学员会收到任务通知，移除的学员会收到任务撤销通知，已指派人员不再收到任务
        </p>
      </div>
      <div slot="footer" class="dialogtimefoot">
        <el-button type="primary" @click="delayTimeUp">确定</el-button>
        <el-button @click="changeArr = false">取消</el-button>
      </div>
    </el-dialog>
    <dialogFw
      :visible.sync="visible"
      :bmid.sync="bmid"
      @bmidfw="bmidfwtxt"
    ></dialogFw>
  </div>
</template>

<script>
import comheader from "../Common/comheader";
import comtop from "../Common/comtop";
import commonPage from "../Common/page";
import dialogFw from "../Common/dialog";
import { checkindex } from "@/https/index";

export default {
  name: "task",
  inject: ["reload"],
  data() {
    return {
      input: "",
      checked: false,
      taskList: [],
      delayTime: false,
      s_time: "",
      id: "",
      radio: "1",
      visible: false,
      pickerOptionsEnd: {},
      limit: 10, //一页几条数据
      count: 0, //数据总计
      bmid: 0,
      page: 1, //当前页数
      delid: [],
      e_time: "",
      changeArr: false,
      inGlist: [],
      uid: localStorage.getItem("userid"),
      isCollapse: 0,
      tHeadr: [
        {
          label: "考试名称",
          key: "title",
          width: "360",
        },
        {
          label: "考试人",
          key: "examinee",
          width: "97 ",
        },
        {
          label: "满分",
          key: "full_mark",
          width: "70",
        },
        {
          label: "及格",
          key: "passcount",
          width: "70",
        },
        {
          label: "不及格",
          key: "lesscount",
          width: "70",
        },
        {
          label: "未考/缺考",
          key: "no_examination",
          width: "70",
        },
        {
          label: "待阅卷",
          key: "misscount",
          width: "70",
        },
        {
          label: "补考",
          key: "bu_kao",
          width: "70",
        },
        {
          label: "创建人",
          key: "create_name",
          width: "83",
        },
        {
          label: "创建时间",
          key: "create_time",
          width: "160",
        },
        {
          label: "考试期限",
          key: "deadline",
          width: "185",
        },
      ],
    };
  },
  components: {
    comheader,
    comtop,
    commonPage,
    dialogFw,
  },
  methods: {
    levelText(value) {
      console.log(value);
    },
    hrefto() {
      let data = {
        service: "Index.Check_Auth",
        user_id: localStorage.getItem("userid"),
        auth_root: "Examtask.AddExam",
      };
      checkindex(this.HOME, data).then((res) => {
        if (res.data.data.code == "405") {
          this.alertView.failView(res.data.data.msg);
          return false;
        }
        this.$router.push({ path: "/addtask" });
      });
    },
    bmidfwtxt(id, data) {
      console.log(data);
    },
    handleSelectionChange(e) {
      this.delid = e;
    },
    deltakeall() {
      let tid = this.delid.map((item) => {
        return item.t_id;
      });
      tid = tid.join(",");
      console.log(tid);
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("p", null, [h("span", null, "是否删除选中任务")]),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        lockScroll: false,
        showClose: false,
        customClass: "delBtn",
      }).then((action) => {
        var dataUp = {
          service: "Examtask.Exam_DeleteMulti",
          userid: this.uid,
          t_ids: tid,
        };
        this.$axios
          .post(this.HOME, this.$qs.stringify(dataUp))
          .then((res) => {
            console.log(res.data.data.code);
            if (res.data.data.code != 0) {
              this.alertView.failView(res.data.data.msg);
              return false;
            }
            this.alertView.successView("删除成功");
            this.reload();
          })
          .catch(function (error) {
            // 请求失败处理
          });
      });
    },
    delexam(i, id) {
      // console.log(id)
      // var btn = document.getElementsByClassName('exam_delbtn')
      // var data={
      //     service:'Question.QsnDel',
      //     id:id
      // }

      const h = this.$createElement;
      var data = {
        service: "Examtask.Examtaskdel",
        t_id: id,
        userid: localStorage.getItem("userid"),
      };
      this.$msgbox({
        title: "消息",
        message: h("p", null, [h("span", null, "是否确定删除")]),
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        lockScroll: false,
        showClose: false,
        customClass: "delBtn",
      }).then((action) => {
        this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
          if (res.data.data.code == 0) {
            this.taskList.splice(i, 1);
            this.alertView.successView(res.data.data.msg);
          } else {
            this.alertView.failView(res.data.data.msg);
          }
        });
      });
    },
    handleCommand(command) {
      console.log(command);
    },
    logTimeChange(val) {
      console.log(val);
      this.e_time = val;
    },
    handleClick(id) {
      let data = {
        service: "Index.Check_Auth",
        // 'user_id':localStorage.getItem('userid'),
        user_id: 21343,
        auth_root: "Examtask.Examlog",
      };
      checkindex(this.HOME, data).then((res) => {
        if (res.data.data.code == "405") {
          this.alertView.failView(res.data.data.msg);
          return false;
        }
        var tid = id.row.t_id;
        this.$router.push({ path: "/monitor", query: { id: tid } });
      });
    },
    delay(val) {
      let data = {
        service: "Index.Check_Auth",
        user_id: localStorage.getItem("userid"),
        auth_root: "Examtask.Delay",
      };
      checkindex(this.HOME, data).then((res) => {
        if (res.data.data.code == "405") {
          this.alertView.failView(res.data.data.msg);
          return false;
        }
        this.s_time = val.row.s_time;
        this.delayTime = true;
        this.id = val.row.t_id;
      });
    },
    editPeo() {
      this.changeArr = true;
    },
    endtime() {
      let stime = this.s_time;
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate(time) {
          return time.getTime() < new Date(stime).getTime();
        },
      });
    },
    searchtxt() {
      var list = [];
      this.isCollapse = 0;
      this.checked = "";
      var up = {
        service: "Examtask.Examtasklist",
        where: this.input,
      };
      this.$axios
        .post(this.HOME, this.$qs.stringify(up))
        .then((res) => {
          if (res.data.data.info.code == 0) {
            this.count = parseInt(res.data.data.info.count);
            for (var i = 0; i < res.data.data.info.list.length; i++) {
              list.push(res.data.data.info.list[i]);
            }
          } else {
            this.alertView.failView("没有搜索到该试题");
            this.count = 1;
          }
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
      this.taskList = list;
    },
    chageMe(e) {
      var List = [];
      var count = 0;
      this.cascaderVal = "";
      this.input = "";
      if (e == true) {
        var data = {
          service: "Examtask.My_ExamMark",
          userid: localStorage.getItem("userid"),
        };
        this.$axios
          .post(this.HOME, this.$qs.stringify(data))
          .then((res) => {
            if (res.data.data.code == 0) {
              this.count = parseInt(res.data.data.count);
              for (let i = 0; i < res.data.data.info.length; i++) {
                List.push(res.data.data.info[i]);
              }
            } else {
              this.count = 0;
            }
            this.taskList = List;
          })
          .catch(function (error) {
            // 请求失败处理
            console.log(error);
          });
      } else {
        this.pagetion(this.limit, this.page);
      }
    },
    bmview(e) {
      this.visible = true;
    },
    delayTimeUp() {
      console.log(this.e_time);
      var dataUp = {
        service: "Examtask.Delay",
        t_id: this.id,
        etime: this.e_time,
        userid: localStorage.getItem("userid"),
      };
      this.$axios
        .post(this.HOME, this.$qs.stringify(dataUp))
        .then((res) => {
          // for(let i=0 ;i <res.data.data.length;i++){
          // data.push(res.data.data[i])
          // }
          // this.taskList=data
          this.reload();
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    radiocount(e) {
      var data = [];
      this.input = "";
      this.checked = "";
      var dataUp = {
        service: "Examtask.Examtasklist",
        state: e,
      };
      this.$axios
        .post(this.HOME, this.$qs.stringify(dataUp))
        .then((res) => {
          if (res.data.data.info.code == 0) {
            for (let i = 0; i < res.data.data.info.list.length; i++) {
              data.push(res.data.data.info.list[i]);
            }
          } else {
            this.count = 0;
          }
          this.count = parseInt(res.data.data.info.count);
          console.log(data);
          this.taskList = data;
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    pagetion(limit, page) {
      var dataUp = {
        service: "Examtask.Examtasklist",
        limit: limit,
        page: page,
        state: this.isCollapse,
        where: this.input,
      };
      var data = [];
      this.$axios
        .post(this.HOME, this.$qs.stringify(dataUp))
        .then((res) => {
          this.count = parseInt(res.data.data.info.count);
          for (let i = 0; i < res.data.data.info.list.length; i++) {
            data.push(res.data.data.info.list[i]);
          }

          this.taskList = data;
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
  },
  mounted() {
    var data = [];
    var coing = [];
    var dataUp = {
      service: "Examtask.Examtasklist",
    };
    this.$axios
      .post(this.HOME, this.$qs.stringify(dataUp))
      .then((res) => {
        this.count = parseInt(res.data.data.info.count);
        for (let i = 0; i < res.data.data.info.list.length; i++) {
          data.push(res.data.data.info.list[i]);
        }
        for (let n in res.data.data.data) {
          coing.push(res.data.data.data[n]);
        }
        this.taskList = data;
        this.inGlist = coing;
      })
      .catch(function (error) {
        // 请求失败处理
      });
  },
};
</script>
<style>
@import "../../assets/css/task.css";
</style>



// WEBPACK FOOTER //
// src/components/task/task.vue